import Swiper from 'swiper/dist/js/swiper.min';
import Vue from 'vue';
import PopupFullscreen from '../popup/fullscreen/popup-fullscreen';
import AnimationFade from '../../core/animation/fade/animation-fade';

export default function () {
  const location = document.querySelectorAll('.location');
  if (location && location.length) {
    [].slice.call(location).forEach((elem) => {
      const object = window.locationData;
      window.VueEvent = new Vue();
      new Vue({
        el: elem,
        delimiters: ['${', '}}'],
        components: {
          AnimationFade,
          PopupFullscreen,
        },
        data() {
          return {
            locationData: object,
            mainSlider: null,
            thumbsSlider: null,
            popupFullOpen: false,
            fullscreenActive: 0,
          };
        },
        mounted() {
          this.slidersInit();
          if (this.$refs && this.$refs.locationSlider) {
            this.$el.classList.remove('location--without-slider');
          } else {
            this.$el.classList.add('location--without-slider');
          }
        },
        methods: {
          slidersInit() {
            if (!this.$el.querySelector('.location__thumb-slider') || !this.$el.querySelector('.location__main-slider')) return;
            this.thumbsSlider = new Swiper(this.$el.querySelector('.location__thumb-slider'), {
              slideToClickedSlide: true,
              slidesPerView: 'auto',
            });

            const thumbs = this.thumbsSlider;

            this.mainSlider = new Swiper(this.$el.querySelector('.location__main-slider'), {
              slidesPerView: 1,
              navigation: {
                nextEl: '.sliderButtons__btn--next',
                prevEl: '.sliderButtons__btn--prev',
              },
              thumbs: {
                swiper: thumbs,
              },
              on: {
                init() {
                  if (thumbs !== undefined && thumbs.slides && thumbs.slides.length > 1) {
                    const slides = [].slice.call(thumbs.slides);
                    if (slides) {
                      slides.forEach(tmp => tmp.classList.remove('location__thumb-slide--active'));
                      slides[this.realIndex].classList.add('location__thumb-slide--active');
                    }
                    thumbs.slideTo(this.realIndex);
                  }
                },
                slideChange() {
                  if (thumbs !== undefined) {
                    const slides = [].slice.call(thumbs.slides);
                    slides.forEach(tmp => tmp.classList.remove('location__thumb-slide--active'));
                    slides[this.realIndex].classList.add('location__thumb-slide--active');
                    thumbs.slideTo(this.realIndex);
                    thumbs.activeIndex = this.realIndex;
                    thumbs.clickedIndex = this.realIndex;
                  }
                },
              },
            });

            this.mainSlider.params.controller.control = this.thumbsSlider;
            this.thumbsSlider.params.controller.control = this.mainSlider;
          },

          openFullPopup() {
            this.fullscreenActive = this.mainSlider ? this.mainSlider.realIndex : 0;
            const popup = this.$el.querySelector('.popup-fullscreen');
            window.bodyLock.disableBodyScroll(popup);
            setTimeout(() => {
              this.popupFullOpen = true;
            }, 500);
          },
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./blocks/location/location.js